import React from 'react';
import PropTypes from 'prop-types';
import { colors } from 'style/config';
import { Box, Text, Flex } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import ChatEntry from 'components/Content/CustomerService/ChatWithUs/ChatEntry';
import { CHAT_ENTRY } from 'constants/chat';

const getText = (text, vars) => localeUtils.getLocaleResourceFile('components/Content/CustomerService/ChatWithUs/locales', 'ChatWithUs')(text, vars);

/**
 * Customer Service contact-strip tile that lets shoppers start a live chat with Sephora
 * support. Renders availability hours and the chat entry button (`ChatEntry`). Driven by
 * the CMS `CS_chatWithUs` rendering type.
 *
 * @param {Object} props
 * @param {string} props.sid - CMS-provided id applied to the tile's root element.
 * @param {Array|number} [props.marginBottom] - Responsive bottom spacing for the tile.
 * @param {Array|string} [props.gridColumn] - Grid column span; set by LayoutCs so the
 *   contact tiles render as equal-width columns.
 * @returns {JSX.Element} The Chat with Us tile.
 */
const ChatWithUs = ({ sid, marginBottom, gridColumn }) => {
    return (
        <Box
            id={sid}
            backgroundColor={colors.nearWhite}
            gridColumn={gridColumn}
            borderRadius={2}
            padding={[4, 5]}
            marginBottom={marginBottom}
        >
            <Text
                is='h2'
                fontWeight={'bold'}
                children={getText('chatWithUs')}
                fontSize='xl-bg'
                marginBottom={1}
            />
            <div>
                <div>
                    <Text fontSize='md'>{getText('representative')}</Text>{' '}
                </div>
                <Flex
                    marginBottom='4'
                    flexDirection='column'
                    gap={0}
                >
                    <div>
                        <Text
                            fontSize='md'
                            fontWeight={'bold'}
                        >
                            {getText('monFri')}:{' '}
                        </Text>
                        <Text fontSize='md'>{getText('monFriTime')}</Text>
                    </div>

                    <div>
                        <Text
                            fontSize='md'
                            fontWeight={'bold'}
                        >
                            {getText('satSun')}:{' '}
                        </Text>
                        <Text fontSize='md'>{getText('satSunTime')}</Text>
                    </div>
                </Flex>
                <ChatEntry type={CHAT_ENTRY.customerService} />
            </div>
        </Box>
    );
};

ChatWithUs.propTypes = {
    sid: PropTypes.string.isRequired,
    marginBottom: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
    gridColumn: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};

export default wrapFunctionalComponent(ChatWithUs, 'ChatWithUs');
